import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { tokenStore, API_URL } from "../setupAxios";

const AuthContext = createContext();

// El access token dura 1h (ver back_app/config.py ACCESS_EXPIRES); se refresca
// proactivamente a los 50 min para que el usuario nunca llegue a sufrir un 401
// por caducidad (el interceptor de setupAxios.js sigue ahí como red de
// seguridad reactiva, p.ej. si el ordenador estuvo suspendido).
const REFRESH_INTERVAL_MS = 50 * 60 * 1000;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch (e) {
      return null;
    }
  });

  // Guarda usuario + tokens tras un login correcto.
  const login = ({ user: userData, access_token, refresh_token }) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    tokenStore.set(access_token, refresh_token);
  };

  const logout = () => {
    setUser(null);
    tokenStore.clear();
  };

  useEffect(() => {
    if (!user) return;
    const id = setInterval(async () => {
      if (!tokenStore.refresh) return;
      try {
        const { data } = await axios.post(
          `${API_URL}/login/refresh`,
          {},
          { headers: { Authorization: `Bearer ${tokenStore.refresh}` }, withCredentials: true }
        );
        tokenStore.set(data.access_token, data.refresh_token || tokenStore.refresh);
      } catch (e) {
        logout();
        if (window.location.pathname !== "/login") window.location.href = "/login";
      }
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
